import React, { useEffect, useState } from 'react';
import ManagerInsuranceCompaniesCareClaimFilter, {
	CareClaimsFilter,
} from './ManagerInsuranceCompaniesCareClaimFilter';
import ManagerInsuranceCompaniesCareClaimDeleteModal from '../ManagerInsuranceCompaniesCareClaimDeleteModal/ManagerInsuranceCompaniesCareClaimDeleteModal';
import ManagerInsuranceCompaniesCareClaimTable from '../ManagerInsuranceCompaniesCareClaimTable/ManagerInsuranceCompaniesCareClaimTable';
import { useCareClaimsQuery } from '../../../../../../graphql/graphql';
import { useFlatDataList } from '../../../../../Base/Hooks/useFlatDataList';
import { CareClaim } from '../../../../Consts/CareClaimDefaultColumns.const';
import Loading from '../../../../../../Components/Loading';
import { CustomSettingKey } from '../../../../../Base/Enums/CustomSettingKey.enum';
import { CustomSettingsContextProvider } from '../../../../../CustomSettings/Services/CustomSettingsContext';
import styles from './ManagerInsuranceCompaniesCareClaim.module.scss';

const ManagerInsuranceCompaniesCareClaim: React.FC = () => {
	const [deleteCareClaimId, setDeleteCareClaimId] = useState<string>();
	const [filter, setFilter] = useState<CareClaimsFilter>();

	const { flatData, appendData, pagination, getNextPage, reset } =
		useFlatDataList<CareClaim>();
	const { data, isLoading, refetch } = useCareClaimsQuery({
		where: {
			createdById: filter?.doctor?.value || undefined,
			patientId: filter?.patient?.value || undefined,
		},
		pagination,
	});

	useEffect(() => {
		const careClaims = data?.careClaims?.data ?? [];
		if (careClaims.length) {
			appendData(careClaims);
		} else {
			reset();
		}
	}, [data]);

	useEffect(() => {
		refetch();
	}, [filter, refetch]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.CARE_CLAIMS}>
			<div className={styles.wrapper}>
				<ManagerInsuranceCompaniesCareClaimFilter setFilter={setFilter} />
				<div className={styles.tableWrapper}>
					<ManagerInsuranceCompaniesCareClaimTable
						data={flatData}
						isLoading={isLoading}
						onLoadMore={getNextPage}
						onRefresh={refetch}
						hasMoreData={Boolean(data?.careClaims?.meta?.hasNextPage)}
						totalCount={data?.careClaims?.meta?.count ?? 0}
					/>
				</div>
			</div>
			{deleteCareClaimId && (
				<ManagerInsuranceCompaniesCareClaimDeleteModal
					isOpen
					onClose={() => setDeleteCareClaimId(undefined)}
					careClaimId={deleteCareClaimId}
					reloadData={refetch}
				/>
			)}
		</CustomSettingsContextProvider>
	);
};

export default ManagerInsuranceCompaniesCareClaim;
